import React from 'react';
import Nav from 'react-bootstrap/Nav';

const JournalCard = ({title, create_date, update_date, href}) => { 
    return (
        <div className="page-card">
            <div className="w-100 mr3">
                <Nav.Link href={href} style={{ padding: 0 }}><h4>{title}</h4></Nav.Link>
                <h5>Date created: {create_date}</h5>
                <h5>Date updated: {update_date}</h5>
            </div>
        </div>
    );
}

export default JournalCard; 